(ns practitest.frontend.components2.run-status
  (:require [re-frame.core :as re-frame]
            [practitest.frontend.subs :as subs]
            ["react-select" :default Select :refer [components]]))

(def statuses-map
  {"PENDING"       {:label "Pending"
                    :color "var(--pt-color-status-pending)"}
   "RUNNING"       {:label "Running"
                    :color "var(--pt-color-status-running)"}
   "PASSED"        {:label "Passed"
                    :color "var(--pt-color-status-passed)"}
   "FAILED"        {:label "Failed"
                    :color "var(--pt-color-status-failed)"}
   "CANCELED"      {:label "Canceled"
                    :color "var(--pt-color-status-canceled)"}
   "ERROR"         {:label "Error"
                    :color "var(--pt-color-status-error)"}
   "NO RUN"        {:label "No Run"
                    :color "var(--pt-color-status-no-run)"}
   "NOT INCLUDED"  {:label "Not Included"
                    :color "var(--pt-color-status-not-included)"}
   "BLOCKED"       {:label "Blocked"
                    :color "var(--pt-color-status-blocked)"}
   "NOT COMPLETED" {:label "Not Completed"
                    :color "var(--pt-color-status-not-completed)"}
   "N/A"           {:label "N/A"
                    :color "var(--pt-color-status-na)"}})

(defn get-status-label
  [status]
  (when status
    (or (:label (get statuses-map status))
        (str "UNMAPPED STATUS " status))))

(defn get-status-color
  ([status]
   (get-status-color status false))
  ([status is-et]
   (let [status-colors @(re-frame/subscribe [::subs/status-colors])]
     (if is-et (get status-colors status) (:color (get statuses-map status))))))

(defn run-status-component
  [status]
  [:<>
   [:span.status-indicator
    {:style {:color (get-status-color status)}}]
   (get-status-label status)])
